import styled from 'styled-components';
import PageTop from '../components/pageTop/PageTop';
import Menu from '../components/menu/Menu';
import { useEffect, useRef, useState } from 'react';
import AuctionCalendar from '../main/components/calander/Calander';
import LoanInfoService from '../../service/LoanInfo';
import Footer from '../components/footer/Footer';
import List from '../components/list/List';
import { FilterType, Region } from '../search/FilterData';
import AddInterestItemModal from '../components/modal/AddInterestItem';
import ScrollToTopButton from '../components/ScrollToTopButton';

type SortOption = { value: string; label: string };
const AuctionSchedule = () => {
  const param = new URLSearchParams(window.location.search);
  const url_court = param.get('court');
  const url_date = param.get('date');

  const [openMenu, setOpenMenu] = useState(false);
  const [court, setCourt] = useState<string>(url_court ?? '');
  const [tabCategory, setTabCategory] = useState<string>('a');
  const [calendarData, setCalendarData] = useState([]);
  const [curCalendarData, setCurCalendarData] = useState([]);
  const [total, setTotal] = useState<number>(0);
  const [data, setData] = useState([]);
  const [sort, setSort] = useState<SortOption>({
    value: 'DA',
    label: '매각기일 빠른순',
  });
  const [filters, setFilters] = useState<FilterType>({
    type: 'a',
    regionOrCourt: 'r',
    region: [] as Region[],
    court: '',
    itemStatus: [],
    multiItemStatus: [],
    appraisalPrice: { min: '', max: '' },
    minPrice: { min: '', max: '' },
    saleDate: { start: '', end: '' },
    approvalDate: { start: '', end: '' },
    buildingArea: { min: '', max: '' },
    landArea: { min: '', max: '' },
    bidStatus: '',
    progressStatus: '진행',
    useArea: [],
    multiUseArea: [],
    specialConditionViewOption: 'o',
    specialItemCondition: [],
    multiSpecialItemCondition: [],
    holdingCompany: [],
    multiHoldingCompany: [],
  });
  const [selectedDate, setSelectedDate] = useState(
    url_date
      ? url_date
      : new Date()
          .toLocaleDateString('ko-KR', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
          })
          .replace(/\. /g, '-')
          .replace('.', ''),
  );
  const prevCourt = useRef(court);
  const [offset, setOffset] = useState<number>(0);
  const [loading, setLoading] = useState(false);
  const [showLikeModal, setShowLikeModal] = useState<boolean>(false);
  const [mode, setMode] = useState<string>('add');
  const [selectedIdx, setSelectedIdx] = useState<number>(0);
  const [selectedItem, setSelectedItem] = useState({
    iidx: 0,
    group: '',
    group_idx: 0,
    level: 0,
    memo: '',
  });

  const [limit, setLimit] = useState<number>(10);
  const [activeItem, setActiveItem] = useState<number | null>(null);
  const getList = async (filters?: any) => {
    try {
      const res = await LoanInfoService.calendar(
        court,
        '',
        selectedDate,
        tabCategory,
        sort.value,
        limit,
        offset,
      );
      setData(res.data.list);
      setTotal(res.data.totalNumber);
      setCalendarData(res.data.calendar);
      setCurCalendarData(res.data.cur_calendar);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    getList();
    prevCourt.current = court;
  }, [selectedDate]);
  useEffect(() => {
    if (prevCourt.current === court) return; // court 값이 변경되지 않았으면 실행 안 함
    prevCourt.current = court; // court 값 업데이트

    setOffset(0);
    getList();
  }, [court]);

  useEffect(() => {
    if (offset === 0) return;
    getList();
  }, [offset]);
  const prevSort = useRef(sort);
  useEffect(() => {
    if (prevSort.current === sort) return; // sort 값이 변경되지 않았으면 실행 안 함
    if (data.length === 0) return;
    setOffset(0);
    getList();
    prevSort.current = sort; // 이전 sort 값 업데이트
  }, [sort]);

  return (
    <Container>
      <ScrollToTopButton/>
      <PageTop text={'경매일정'} setOpenMenu={setOpenMenu} />
      <Inner>
        <AuctionCalenderBox>
          <AuctionCalendar
            page="auctionSchedule"
            court={court}
            setCourt={setCourt}
            calendarData={calendarData}
            curCalendarData={curCalendarData}
            tabCategory={tabCategory}
            selectedDate={selectedDate}
            setSelectedDate={setSelectedDate}
          />
        </AuctionCalenderBox>
        <List
          data={data}
          totalCount={total}
          sort={sort}
          setSort={setSort}
          setOffset={setOffset}
          filters={filters}
          limit={limit}
          loading={loading}
          page="search"
          setSelectedIdx={setSelectedIdx}
          setShowLikeModal={setShowLikeModal}
          setMode={setMode}
          setSelectedItem={setSelectedItem}
          activeItem={activeItem}
          setActiveItem={setActiveItem}
          getList={getList}
        />
        {showLikeModal && (
          <AddInterestItemModal
            setShowLikeModal={setShowLikeModal}
            selectedIdx={selectedIdx}
            mode={mode}
            selectedItem={selectedItem}
            getList={getList}
            offset={offset}
            sort={sort}
            filters={filters}
            setActiveItem={setActiveItem}
          />
        )}
        <Footer />
      </Inner>
      {openMenu && <Menu page="main" setOpenMenu={setOpenMenu} />}
    </Container>
  );
};
export default AuctionSchedule;

const AuctionCalenderBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 32px 16px;
`;

const Inner = styled.div`
  width: 100%;
`;
const Container = styled.div`
  max-width: 900px;
  min-height: 100vh;
  margin: 0 auto;
  box-shadow: 0 0 20px hsla(0, 0%, 51%, 0.15);
  position: relative;
`;
